import React from 'react' 
import promotion  from '../../../../Images/Promoting Your Services.png' 
import trafficc from '../../../../Images/Most inbound traffic.png' 
import leads from '../../../../Images/Leads.png' 
import awareness from '../../../../Images/Brand awareness.png' 
import csatis from '../../../../Images/Better Customer Satisfaction.png' 


import Influencer from '../../../../Images/SMO_In_ Partnerships.png' 
import paidadv from '../../../../Images/SMO_In_ Paid Advertising.png' 
import community from '../../../../Images/SMO_In_ Community.png' 
import posting from '../../../../Images/SMO_In_ Posting.png' 
import Competitor  from '../../../../Images/SMO_In_ Competitor.png' 
import Monitoring  from '../../../../Images/SMO_In_ Monitoring.png' 


function SMOGrowBusiness() {
    return (
        <>
            <div className="container-fluid seo-growbusiness">
                <div className="container-xl">
                    <div className="row growbusiness-text">
                        <h1>How Can We Help You Grow Your Business through SMO? </h1>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box  '>
                                <img src={awareness} alt="" width={55} />
                                <h2>Enhancing Brand Awareness</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={trafficc} alt="" width={55} />
                                <h2>Driving  inbound Traffic</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={promotion} alt="" width={55} />
                                <h2>Promoting Products and Services</h2>
                            </div>
                        </div>
                         
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={csatis} alt="" width={55} />
                                <h2>Improving Customer Satisfaction</h2>
                            </div>
                        </div>
                        <div className="col-lg-2 col-6 col-sm-4 col-md-3 mb-3">
                            <div className='growbusiness-box '>
                                <img src={leads} alt="" width={55} />
                                <h2>Increasing Conversion Rates</h2>
                            </div>
                        </div>
                         
                    </div>
                </div>
            </div>

            <div className="container-fluid  mb-5">
                <div className="container-xl">
                    <div className="row seo-work">
                        <h1>Our Smo Work Includes</h1>
                        <p>Our SMO work focuses on elevating brand presence and engagement through tailored strategies. We optimize profiles, curate engaging content, nurture communities, optimize hashtags, strategize content sharing, and provide analytics for your business growth.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Influencer} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Influencer Partnerships</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>To boost reach, we collaborate with industry influencers in the digital age, tapping into their audience for credibility and recognition.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={paidadv} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Paid Advertising Campaigns</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>For a precise audience, we create & manage ad campaigns on social media, driving brand visibility & conversions with data-driven strategies.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={community} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Community Management</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Nurturing a vibrant online community, fostering positive interactions, and addressing concerns promptly result in loyalty and satisfaction.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={posting} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Regular Posting Schedule</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Prioritize consistency in posting, keeping your audience engaged and well-informed, and boosting brand recognition and customer retention.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Competitor} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Competitor Analysis</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Studying rivals is vital for us. We analyze their tactics to refine ours, staying competitive and adaptive for your brand's success.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-4 col-3">
                                    <img src={Monitoring} alt="" width={60} />
                                </div>
                                <div className="col-md-9 col-sm-8 col-9 seo-work-text">
                                    <h3>Monitoring Trends</h3>
                                </div>
                            </div>
                            <div className="row pb-3 seo-work-text">
                                <p>Stay updated with social media trends, integrating them into the SMO strategy to maximize the brand's impact and stay ahead in digital marketing.</p>
                            </div>
                        </div>



                    </div>
                </div>
            </div>

        </>
    )
}

export default SMOGrowBusiness